/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * Minimal site-wide footer with legal links and copyright.
 */

import { Link } from '@tanstack/react-router';
import { Box, Container, Typography, Stack, Divider } from '@mui/material';
import { analytics } from '@/lib/analytics';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 'auto' }}>
      <Divider />
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          sx={{ py: 2.5 }}
        >
          <Typography variant="body2" color="text.secondary">
            &copy; {year} Christian Battaglia
          </Typography>
          <Stack direction="row" spacing={3}>
            <Typography
              component={Link}
              to="/privacy-policy"
              variant="body2"
              color="text.secondary"
              onClick={() => analytics.navigationClicked('/privacy-policy', 'footer')}
              sx={{ textDecoration: 'none', py: 1, px: 0.5, '&:hover': { textDecoration: 'underline' } }}
            >
              Privacy Policy
            </Typography>
            <Typography
              component={Link}
              to="/terms-of-service"
              variant="body2"
              color="text.secondary"
              onClick={() => analytics.navigationClicked('/terms-of-service', 'footer')}
              sx={{ textDecoration: 'none', py: 1, px: 0.5, '&:hover': { textDecoration: 'underline' } }}
            >
              Terms of Service
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
